import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/content";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-secondary py-24 sm:py-32 lg:py-44"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="max-w-2xl mb-16 sm:mb-24">
          <Reveal>
            <p className="overline mb-6">In Their Words</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight text-foreground leading-none">
              Trusted by those who sell the extraordinary.
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-border">
          {TESTIMONIALS.map((t, i) => (
            <Reveal
              key={t.name}
              delay={i * 0.12}
              className="bg-secondary p-9 sm:p-11 flex flex-col"
            >
              <p className="font-display font-light text-2xl sm:text-[1.7rem] leading-snug text-foreground flex-1">
                “{t.quote}”
              </p>
              <div className="mt-10 pt-6 border-t border-border">
                <p className="text-sm font-medium text-foreground tracking-wide">
                  {t.name}
                </p>
                <p className="text-xs text-muted-foreground mt-1 tracking-wide uppercase">
                  {t.role}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
